import styled from "styled-components";
import Chip from "../Chip";
import Table from "../DataTable";
import ActionImageButton from "../DataTable/ActionImageButton";
import { getFormattedDate } from "../getFormattedDate";
import ListWithPagination from "../ListsWithPagination";
import { TableWithPagination } from "../TableWithPagination";

interface Props {
  data: any;
  onEdit: (id: string) => void;
  isTableDataLoading: boolean;
  currentPage: any;
  totalData: any;
  rowsPerPage: any;
  onPageChange: any;
}

const PromotionTable = ({
  data,
  onEdit,
  isTableDataLoading,
  currentPage,
  totalData,
  rowsPerPage,
  onPageChange,
}: Props) => {
  const columns = [
    {
      path: "_id",
      label: "ID",
    },
    {
      path: "code",
      label: "Promo Code",
    },
    {
      path: "name",
      label: "Title",
    },
    {
      path: "description",
      label: "Info",
      content: (data: any) => (
        <div style={{ width: "270px" }}>{data.description}</div>
      ),
    },
    {
      path: "startDate",
      label: "Start Date",
      content: (data: any) => (
        <div>{getFormattedDate(data.startDate, "DD MMMM YYYY")}</div>
      ),
    },
    {
      path: "endDate",
      label: "End Date",
      content: (data: any) => (
        <div>
          {getFormattedDate(data.endDate.split("T")[0], "DD MMMM YYYY")}
        </div>
      ),
    },
    {
      key: "isActive",
      label: "Status",
      content: (item: any) => (
        <Chip
          label={item?.isActive ? "Active" : "Inactive"}
          variant={item?.isActive ? "success" : "error"}
        />
      ),
    },
    {
      label: "Action",
      key: "edit",
      content: (item: any) => (
        <ActionImageButton
          onClick={() => onEdit(item._id)}
          iconPath={require("../../assets/images/edit-icon.png")}
          label="Edit Category"
        />
      ),
    },
  ];

  return (
    <>
      <TableWrapper>
        <TableWithPagination
          columns={columns}
          data={data}
          currentPage={currentPage}
          totalData={totalData}
          rowsPerPage={rowsPerPage}
          onPageChange={onPageChange}
          isTableDataLoading={isTableDataLoading}
        />
      </TableWrapper>
      <ListWrapper>
        <ListWithPagination
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          title={"Promotion"}
          hidePagination={false}
          currentPage={currentPage}
          totalData={totalData}
          rowsPerPage={rowsPerPage}
          onPageChange={onPageChange}
        />
      </ListWrapper>
    </>
  );
};

const TableWrapper = styled.div`
  display: block;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

export default PromotionTable;
